import DateTimePicker from 'lib/DatePicker/DateTimePicker';
import { DateFilterKey } from './AdvancedFilters.types';

interface DateFilterPanelProps {
  dateKey: DateFilterKey;
  selectedDate?: Date;
  onChange: (value: Date) => void;
}

export const DateFilterPanel = ({ dateKey, selectedDate, onChange }: DateFilterPanelProps): React.ReactElement => (
  <div className="bg-white border border-neutral-200 rounded-md overflow-hidden shadow-dropdownMenu p-3">
    <DateTimePicker
      value={selectedDate}
      onChange={onChange}
      isOpen
      isTimePickerEnabled={false}
      disabledDays={dateKey === 'createdAt' ? { after: new Date() } : undefined}
    />
  </div>
);
